// src/services/composerService.ts
import apiClient from '../utils/apiClient';

interface Composer {
  composer_id: number;
  full_name: string;
  type: string;
  era?: string;
  origin?: string;
  additional_info?: string;
}

export const composerService = {
  searchComposers: async (term: string, type?: string): Promise<Composer[]> => {
    try {
      console.log('Searching composers with:', { term, type }); // Debug log

      const response = await apiClient.get<{ composers: Composer[] }>('/composers/search', {
        params: { 
          term: term.trim(),
          ...(type && { type })
        }
      });

      console.log('Search response:', response.data); // Debug log
      return response.data.composers;
    } catch (error) {
      console.error('Error searching composers:', error);
      throw error;
    }
  }
};